export default function createValidator(spec) {
  var keys = Object.keys(spec);
  return function (x) {
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      var _spec$key = spec[key](x[key]),
          pass = _spec$key.pass,
          type = _spec$key.type;

      if (!pass) {
        throw new TypeError('Expected `' + key + '` to be of type `' + type + '`.');
      }
    }
  };
}